import { writable } from 'svelte/store';
import { API } from '../../public/api.js';

export var io = writable({
    PublishMode: true,

    API: API,
    token: null,

    streamers: [],
    user: {
        eggs: 0,
        food:0,
        hatches: [],
        silver:0
    },


    serve: function(endpoint, body, done){
        var url = this.PublishMode ? window.location.origin : 'http://localhost:3262';

        fetch(`${url}/${endpoint}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        }).then(res => {
            if(res.status == 500)
                done(null);
            res.json().then(data=>{
                if(data.error)
                    return done(null);
                else
                    done(data);
            })
        }).catch((er)=>{
            console.log(er);
        })
    }
});